import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CONDITION } from "./abstract/conditionAbstract";

const _action = `${ACTION_PREFIX_CONDITION}_remove`;
const _header = `Remove condition`;

export const removeCondition = (root, id) => {
  const _payload = removeConditionLogic(root, id);

  logger.logAction(_action, _payload, ACTION_PREFIX_CONDITION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const removeConditionLogic = (root, id) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  if (!_node) {
    throw new Error("Condition to remove not found");
  }
  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  removeNode(_index, _nodeParent);

  return generatePayload(_nodeBackup, _index, _nodeParent);
};

const removeNode = (index, nodeParent) => {
  nodeUtils.modifyConditions(nodeParent, (e) => e.splice(index, 1), false);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent) => {
  const _payload = {
    group: ActionGroupTypes.DELETE,
    status: nodeUtils.getName(node) ? ActionStatusTypes.SUCCESS : ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node, nodeParent),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
  };

  return systemUtils.createDeepCopy(_payload);
};

const generatePayloadDescription = (node, nodeParent) => {

  if (nodeUtils.isFunction(nodeParent)) {
    return `Delete function logic '${nodeUtils.getName(node)}'.`;
  }

  return `Delete structure logic '${nodeUtils.getName(node)}'.`;
}